import {
  IApiCoverageServer,
  IApiCoverageServerCreate,
  IApiCoverageServerParameters,
  IApiCTraderParameters,
  IApiMt5Parameters,
} from '@cbridge-packages/api-coverage';
import { CoverageServerType, ICoverageServer, ICoverageServerForm } from './coverageServer.interface';

export namespace CoverageServerTranslator {
  export function fromApi(server: IApiCoverageServer): ICoverageServer {
    const base = {
      serverId: server.id,
      name: server.name,
      type: server.type as CoverageServerType,
    };
    if (server.type === 'MT5') {
      const parameters = server.parameters as IApiMt5Parameters;
      return {
        ...base,
        secret: parameters.secret,
        managerId: parameters.managerId,
        host: parameters.host,
        port: parameters.port,
      };
    }
    const parameters = server.parameters as IApiCTraderParameters;
    return {
      ...base,
      plant: parameters.plant,
      environment: parameters.environment,
      managerLogin: parameters.managerLogin,
      managerPassword: parameters.managerPassword,
    };
  }

  export function toApi(form: ICoverageServerForm): IApiCoverageServerCreate {
    const parameters: IApiCoverageServerParameters = form.type === CoverageServerType.MT5
      ? { secret: form.secret, managerId: form.managerId, host: form.host, port: form.port }
      : { plant: form.plant, environment: form.environment, managerLogin: form.managerLogin, managerPassword: form.managerPassword };
    return {
      name: form.name,
      type: form.type,
      parameters,
    };
  }

}
